import {Image, Row, Typography, Col} from 'antd'
import React from "react"
import AvatarManSVG from "../../image/dashboard/avatar_muz.svg"
import AvatarWomanSVG from "../../image/dashboard/avatar_zena.svg"

export function ProfileWidget({gender, title, email}) {
  return (
    <div className="profile-widget">
      <Row>
        <Col xs={18} md={18} xl={18}>
          <Row align="center" justify="center">
            <Col xs={24} md={24} xl={24}>
              <Typography.Title className="profile-title" level={4}>{title}</Typography.Title>
            </Col>
            <Col xs={24} md={24} xl={24}>
              <Typography.Text className="profile-email" level={4}>Email: {email}</Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col xs={6} md={6} xl={6} className="profile-avatar">
          <Image preview={false} src={gender === "2" ? AvatarWomanSVG : AvatarManSVG}></Image>
        </Col>
      </Row>

    </div>
  )
}